// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState =
  {
    PauseStateNotPaused: 'not-paused',
    PauseStateScaleDownCompute: 'scale-down-compute',
  } as const;
export type GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState =
  (typeof GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState)[keyof typeof GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState];

export function instanceOfGithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState(
  value: any,
): boolean {
  for (const key in GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState) {
    if (
      Object.prototype.hasOwnProperty.call(
        GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState,
        key,
      )
    ) {
      if (
        GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState[
          key as keyof typeof GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateFromJSON(
  json: any,
): GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState {
  return GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateFromJSONTyped(
    json,
    false,
  );
}

export function GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState {
  return json as GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState;
}

export function GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateToJSON(
  value?: GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState | null,
): any {
  return value as any;
}

export function GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState {
  return value as GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState;
}
